<template>
  <div class="setPassWord">
    <header>
      <p v-on:click="backHistory" style="margin-left: 1rem; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">设置密码</span>
      </p>
    </header>
    <!--<header class="header divflex">-->
      <!--&lt;!&ndash;<a href="index.html" class="backlastpage"></a>&ndash;&gt;-->
      <!--<h3>首页</h3>-->
    <!--</header>-->
    <div class="main">


    <van-form @submit="onSubmit">
      <van-field class="marginTop"
        v-model="password1"
        name="请设置密码"
        label="请设置密码"
        placeholder="请设置密码"
        :rules="[{ required: true, message: '请设置密码' }]"
      />
      <van-field
        v-model="password2" class="marginTop"
        type="password"
        name="请再次输入密码"
        label="请再次输入"
        placeholder="请再次输入密码"
        :rules="[{ required: true, message: '请再次输入密码' }]"
      />
      <div class="marginTop">
        <van-button round block type="info" native-type="submit" @click="newPassWorder()">
          确认设置
        </van-button>
      </div>
    </van-form>
    <div class="passbotwrap marginTop">
      <a href="">修改密码</a>
      <a href="">找回密码</a>
    </div>
    <p style="margin-top: 20%">&nbsp;&nbsp;&nbsp;&nbsp;注：如果您登录使用的是验证码登录，可以在上方设置您的登录密码，设置成功后可以使用此密码进行登录。</p>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'setPassWord',
    data () {
      return {
        username: '',
        password1: '',
        password2:''
      };
    },
   methods: {
     onSubmit(values) {
       console.log('submit', values);
     },
     backHistory(){
       this.$router.go(-1)
     },
     backHistory(){
       this.$router.go(-1)
     },
     newPassWorder(){//
//        console.log(typeof Number())
    console.log(this.password1)
    console.log(this.password2)
    if(this.password1===this.password2){
      this.$api.newPassWord({'user_id':localStorage.getItem("userid"),'pwd':this.password2}).then(res=>{
//          this.$api.codeLogin({'mobile':17610336967,'logintype':2,password:"xi000000"}).then(res=>{
          if(res.status==200){
            this.$toast("设置成功")
//            localStorage.setItem("userid",res.userid)
//              console.log( localStorage.getItem("userid"))
            this.$router.push('/')
          }
        }
      )
    }else {
      this.$toast("俩次密码输入不一致，请重新输入")
    }
  },
   },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  header{
    width: 100%;
    height: 80px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/

    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .main{
    width: 90%;
    margin: 40% auto 0 auto;
  }
  .passbotwrap a {
    margin-left: 20%;
    /*display: block;*/
    line-height: 10%;
    color: #007aff;
    margin-top: 10px;
  }
  .marginTop{
    margin-top: 10%;
  }
  .van-button--block{
    width: 80%;
    margin: auto;
  }
  .setPassWord{
    /*background-color: #858585;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/setPassWord.vue